/**
 * Attempts to recover from WalletConnect-related errors by clearing corrupted IndexedDB data.
 * This function will only attempt recovery once every 30 seconds to prevent infinite reload loops.
 *
 * @returns Promise<boolean> - Returns true if recovery was attempted and page will reload, false otherwise
 */
export const handleWalletConnectRecovery = async (): Promise<boolean> => {
	try {
		const attempted = window.localStorage.getItem("wallet-connect-reset");
		const now = Date.now();

		// Check if recovery was already attempted in the last 30 seconds
		if (attempted !== null && now - Number.parseInt(attempted) <= 30_000) {
			console.log("wallet-connect-reset was not applied as it has been attempted recently");
			return false;
		}

		// Check if WalletConnect IndexedDB exists
		const databases = await window.indexedDB.databases();
		const found = databases.find(db => db.name === "WALLET_CONNECT_V2_INDEXED_DB");

		if (found) {
			// Delete the corrupted database
			await window.indexedDB.deleteDatabase("WALLET_CONNECT_V2_INDEXED_DB");
			window.localStorage.setItem("wallet-connect-reset", Date.now().toString());

			console.log("wallet-connect-reset has been applied - reloading page");

			// Reload the page after a brief delay
			setTimeout(() => {
				window.location.reload();
			}, 100);

			return true;
		}

		console.log("wallet-connect-reset was not applied - indexed db was not found");
		return false;
	} catch (error) {
		console.error("Error during WalletConnect recovery:", error);
		return false;
	}
};
